/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ThemeOptions } from '@mui/material/styles';

export const elevationShadows: ThemeOptions = {
	elevationShadows: {
		stickyShadows: {
			default: 4,
		},
		cardPopupShadows: {
			default: 6,
		},
		paperShadows: {
			default: 1,
		},
	},
} as ThemeOptions;
